import { SET_LOADING, ELoadingType } from 'store/loading/types';

export function setLoading(loading: ELoadingType) {
  return {
    type: SET_LOADING,
    loading,
  };
}
